// extracted by mini-css-extract-plugin
export default {"container":"ScrollContainer_container__Q7ZWe","loaderContainer":"ScrollContainer_loaderContainer__RBhqb"};